import {Component, forwardRef, Injector, Input, Optional} from "@angular/core";
import {ColumnComponent} from "../../../grid/column.component";
import {SearchActionEvent} from "../../search-page/search-action-event";
import {FUIStackedPageContextService} from "@fedeltapointofsale/ui";
import {AbstractColumnComponent} from "../../../grid/abstract-column.component";
import {SearchType} from "../../search-page/extended-search-params";

/**
 * Main grid column.
 *
 * In select mode, the field is rendered with a select button emits a select-single action event when clicked.
 * Otherwise, the field is rendered as a link that emits an edit action event when clicked.
 *
 * A "discontinued" flag may also be optionally included in the search data to render a discontinued label next
 * to the clickable name
 */
@Component({
    selector: "wbo-main-search-column",
    templateUrl: "./main-search-column.component.html",
    styleUrls: ["./main-search-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => MainSearchColumnComponent), multi: true}
    ]

})
export class MainSearchColumnComponent extends AbstractColumnComponent {

    @Input() valueGetter: (this: void, dataItem: any) => any;
    @Input() discontinuedLabel: string = "wbo.common.label.discontinued";

    constructor(injector: Injector,
                @Optional() private stackedPageContextService: FUIStackedPageContextService) {
        super(injector);
    }

    /**
     * Invoked when the link is clicked
     * @param dataItem - row data
     */
    fireEditEvent(dataItem: any) {
        this.itemAction.emit(new SearchActionEvent(SearchActionEvent.ACTION_EDIT, dataItem));
    }

    get isSelectMode(): boolean {
        return this.stackedPageContextService != undefined && this.stackedPageContextService.params.searchType !== SearchType.NO_SELECTION;
    }

    getValue(dataItem: any): any {
        if (this.valueGetter) {
            return this.valueGetter(dataItem);
        } else {
            return dataItem[this.field];
        }
    }
}
